/**
 * Shared chrome for the org-planning pages — the Org Planning Overview and Role Approvals.
 *
 * These constants started life inside `InternalPlaygroundHiringTimelineView.tsx`. They live here
 * because the two pages sit next to each other in the sidebar and link to one another, so a
 * Refresh button that is blue on one and grey on the other reads as two different tools. Two local
 * copies would have drifted the first time either was touched.
 */

/**
 * One radius for every box on these pages — tab bars, dropdowns, buttons, tables, banners, cards
 * (David, Sep 2026). `rounded-md` rather than the atoms' 2-4px because `MultiSelect` already sits
 * at 6px and the cockpit's own chrome is 6/8px; picking the value the shared component already
 * uses is what keeps this to overrides on these pages' own elements instead of a change that
 * reaches the ticketing views.
 */
export const RADIUS = 'rounded-md';

/**
 * FINN blue, not black (David, Sep 2026). The design-system `outline` variant is black-on-white
 * going black-on-hover; this is the same shape in `trustedBlue`.
 */
export const BLUE_BUTTON =
  `${RADIUS} border-trustedBlue text-trustedBlue fill-trustedBlue ` +
  'hover:border-trustedBluePressed hover:bg-trustedBluePressed hover:text-white hover:fill-white ' +
  'active:border-trustedBluePressed active:bg-trustedBluePressed active:text-white active:fill-white';

/**
 * What puts the gap between a button's icon and its label. A `gap` on the button itself never
 * reaches them, because the atom wraps its children in a flex div of its own.
 */
export const BUTTON_CONTENT = 'gap-2';
